// components/Text.js
import React from 'react';
import { Text as PdfText } from '@react-pdf/renderer';
import compose from '../styles/compose';

export default function Text({ className, pdfMode, value, children, style, ...rest }) {
  // prefer `value`, fallback to `children`, otherwise empty
  const raw = value != null ? value : (children != null ? children : '');
  const content = Array.isArray(raw) ? raw.join('') : String(raw);

  if (pdfMode) {
    // Only PDF primitives in pdf mode
    return (
      <PdfText style={compose('span ' + (className || ''))} {...rest}>
        {content}
      </PdfText>
    );
  }

  return (
    <span className={'span ' + (className || '')} style={style} {...rest}>
      {content}
    </span>
  );
}
